let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kVX56"), load("ffQaD"), load("kvRbA"), load("76n7a"), load("l253H"), load("1CxlJ")]).then(() => parcelRequire('8rIQt'));